import { render } from "./AIRecommendationsCache.vue?vue&type=template&id=3289dd0d"
import script from "./AIRecommendationsCache.vue?vue&type=script&lang=js"
export * from "./AIRecommendationsCache.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__